<template>
    <tr class="center aligned">
        <td> {{ distribution.priority || '-' }} </td>
        <td> {{ distribution.name || '-' }} </td>
        <td>
            <span v-if="distribution.strategy == 'direct'">
                {{ $t('ui.pages.distributions.filter.direct') }}
            </span>
            <span v-else-if="distribution.strategy == 'intermodal'">
                {{ $t('ui.pages.distributions.filter.intermodal') }}
            </span>
            <span v-else>
                {{ distribution.strategy }}
            </span>
        </td>
        <td> {{ distribution.station ? distribution.station.name : '-'}} </td>
        <td> {{ distribution.material ? distribution.material.name : '-'}} </td>
        <td>
            <i class="check icon" v-if="distribution.is_activated"></i>
            <i class="remove icon" v-else></i>
        </td>
        <td class="center aligned">
            <router-link
                :to="{name: 'edit_provider_distribution', params: {identity: distribution.identity}}"
                class="ui basic primary button"
            >
                {{ $t('ui.general.detail') }}
            </router-link>
            <button class="ui basic negative button"
                v-bind:class="{ 'loading': distribution.is_processing }"
                @click="$parent.delete_distribution(distribution)"
            >
                {{ $t('ui.general.delete') }}
            </button>
        </td>
    </tr>
</template>

<script>
import moment from 'moment'
export default {
    name: "ProviderDistributionsIndexItem",
    props: {
        distribution: Object
    },
    data() {
        return {
            is_processing: false,
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
    }
}
</script>
